import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import socketClient from "../../websockets/client";
import { fetchNotifications } from "../../state/notification/reducers";

export function Notifications() {
    const token = useSelector(state => state.auth.token)

    const dispatch = useDispatch();


    useEffect(() => {
        socketClient.connect(token);
        dispatch({ type: 'notifications/syncNotifications' });

        return () => {
            socketClient.disconnect();
        }

    }, [token, dispatch])

    useEffect(() => {
        if (token)
            dispatch(fetchNotifications());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, dispatch]);






    return <></>


}